<template>
  <span class="quoteActionsButtonWrapper">
    <app-button
      type="button"
      data-qa="save-quote-button"
      :disabled="disabled || loadingSave"
      class="quoteActionsButton"
      @click="saveQuote"
    >
      {{ title }}
      <loader v-if="loadingSave" />
    </app-button>
  </span>
</template>

<script>
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import AdditionalOrder from '@/mixins/additionalOrder.js'

export default {
  components: {
    Loader,
    AppButton,
  },
  mixins: [AdditionalOrder],
  props: {
    title: {
      type: String,
      default: 'Tussentijds opslaan',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingSave: false,
    }
  },
  methods: {
    saveQuote() {
      this.loadingSave = true

      this.$store
        .dispatch(`${this.quoteNamespace}/createOrUpdate`)
        .then((response) => {
          if (!this.additionalQuote && this.$route.name != 'configuration-page') {
            // new quote

            let params = {
              ...this.$route.params,
              quoteId: response.data.QuoteId,
            }

            this.$router.push({
              name: 'configuration-page',
              params,
              force: true,
            })
          }
        })
        .finally(() => (this.loadingSave = false))
    },
  },
}
</script>
